/* eslint-disable */
enum ButtonIconPosition {
  LEFT = 'left',
  RIGHT = 'right',
}

enum ButtonStyles {
  SOLID = 'solid',
  OUTLINE = 'outline',
}

enum ButtonSize {
  EXTRA_SMALL = 'extra-small', // 24px Tall
  SMALL = 'small', //36px Tall
  MEDIUM = 'medium', //48px Tall
}

enum ButtonTypes {
  SUBMIT = 'submit',
  RESET = 'reset',
  BUTTON = 'button',
}

enum ButtonWidth {
  FIT_CONTENT = 'fit-content',
  FULL_WIDTH = 'full-width',
}
export { ButtonIconPosition, ButtonStyles, ButtonSize, ButtonTypes, ButtonWidth };
